





























import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component
export default class FloatingWindow extends Vue {
  @userModule.Getter('getFloatingWindow') floatingWindow: any;

  @Watch('$route')
  handleRouter() {
    const { name } = this.$route;
    const pageCode = (this.floatingWindow && this.floatingWindow.pageCode) || '';
    this.isClosed = false;
    if (pageCode && pageCode.length > 0) {
      if (pageCode.includes('2') && name === 'Index') {
        this.isClosed = true;
      } else if (pageCode.includes('1') && name === 'History') {
        this.isClosed = true;
      }
    } else {
      this.isClosed = false;
    }
  }

  private isClosed: boolean = true;

  // 预通知下线临时通知
  private guideScoreOfflineShow: boolean = true

  private get visible(): boolean {
    if (this.floatingWindow) {
      const nowTime: number = new Date().getTime();
      const { startTime, expireTime } = this.floatingWindow;
      return (this.isClosed && nowTime >= startTime
                && nowTime <= expireTime
                && this.guideScoreOfflineShow);
    }
    return false;
  }

  // 点击浮窗
  private handleClick() {
    this.$utils.sendAction('index', 'history', 'id-9', this.$route.query);
    // const { jumpUrl, code } = this.floatingWindow;
    const { jumpUrl } = this.floatingWindow;
    // // todo 预上线通知
    // if (code === 'scorePreOffline') {
    //   // 点击弹出通知
    //   this.$bus.$emit('showGuideScoreOffline');
    //   this.guideScoreOfflineShow = false;
    //   return;
    // }
    if (jumpUrl) {
      window.open(jumpUrl);
    }
  }

  mounted() {
    // this.$bus.$on('guideScoreOffline', (option: number) => {
    //   if (option === 0) {
    //     this.guideScoreOfflineShow = false;
    //   } else if (option === 1) {
    //     this.guideScoreOfflineShow = true;
    //   }
    // });
  }
}
